import { OVERLAY_OPACITY_ATTRIBUTE } from '../../../constants/attributes';
import isUserModifiedAttributeByElement from '../../../verifiers/is-user-modified-attribute-by-element';

const canEditOverlayOpacity = (targetBlock) =>
  targetBlock &&
  targetBlock.hasAttribute(OVERLAY_OPACITY_ATTRIBUTE) &&
  !isUserModifiedAttributeByElement(targetBlock, OVERLAY_OPACITY_ATTRIBUTE);

export default canEditOverlayOpacity;
